import { createContext } from "react";

import { TriSourceContextState } from "./types";

const TriSourceContext = createContext({} as TriSourceContextState);

export default TriSourceContext;
